import type { Day, Decimal } from '@map-my-money/engine';
import type { Forecasted } from './run.ts';

/** Net worth "now" and its parts: the one definition (see definitions.ts `now`). */
export interface NowState {
  readonly netWorth: Decimal;
  readonly cash: Decimal;
  readonly investments: Decimal;
  readonly debt: Decimal;
  readonly propertyEquity: Decimal;
  readonly assetValue: Decimal;
  /** The check-in now starts from, or null when it is the setup balances' estimate (decision 7). */
  readonly anchor: { readonly waypointId: string; readonly date: Day } | null;
}

/**
 * Now (TIMELINE R19): the position at the end of today, from the latest check-in (or the setup
 * balances) carried forward by everything the map says happened since; the line starts here.
 */
export function nowState(f: Forecasted): NowState {
  const now = f.forecast.now;
  return {
    netWorth: now.netWorth,
    cash: now.cash,
    investments: now.investments,
    debt: now.debt,
    propertyEquity: now.propertyEquity,
    assetValue: now.assetValue,
    anchor: f.checkpoint === null ? null : { waypointId: f.checkpoint.id, date: f.checkpoint.date },
  };
}
